import { toast } from 'react-toastify';

export const showToast = (type = 'error', message, options = {}) => {
  // Prueba para que visualicen como se vería un toast con otras dimensiones
  const defaultOptions = {
    theme: "dark",
    position: "top-center",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    className: 'custom-toast',
  };

  const toastOptions = { ...defaultOptions, ...options };

  switch (type) {
    case 'success':
      toast.success(message, toastOptions);
      break;
    case 'info':
      toast.info(message, toastOptions);
      break;
    case 'warning':
      toast.warn(message, toastOptions);
      break;
    default:
      toast.error(message, toastOptions);
      break;
  }
};